import React from 'react';
import classNames from 'classnames';
import { Link, Props } from '../Link';
import './PageFilterLink.scss';

interface PageFilterLinkProps extends Props {
  back?: boolean;
  selected?: boolean;
}

export const PageFilterLink: React.FC<PageFilterLinkProps> = ({ back, selected, ...rest }) => (
  <Link
    className={classNames('PageFilterLink', {
      'PageFilterLink--back': back,
      'PageFilterLink--selected': selected
    })}
    data-testid="pageFilterLink"
    {...rest}
  />
);
